// BMICalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL, BMI_EndPoint } from "./ConstantsHealthCalculator";
import BMITable from "./BMITable";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Indeks Massa Tubuh (BMI)";
const DESCRIPTION =
  "Apakah tinggi badan Anda sesuai dengan berat badan Anda? Temukan sekarang dengan kalkulator Indeks Massa Tubuh (BMI) - gunakan kalkulator BMI untuk mengukur tingkat kebugaran dan mengevaluasi berat badan sehat";
const KEYWORDS =
  "Indeks Massa Tubuh, hitung BMI, kalkulator BMI, cara menghitung indeks massa tubuh, rumus hitung BMI, indikator kesehatan dan massa tubuh, ketahui BMI saya, BMI sehat, analisis BMI dan berat badan sehat, cara mengevaluasi BMI Anda, ukur massa tubuh, hitung indeks massa tubuh untuk pria, hitung indeks massa tubuh untuk wanita";
const OG_URL = "https://do-calculate.com/calculator/id/bmiadults/";
const apiEndpoint = `${SERVER_URL}/${BMI_EndPoint}`;
function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Indeks Massa Tubuh (BMI) adalah ukuran yang digunakan untuk menentukan status gizi orang dewasa. Ini dihitung dari berat badan seseorang dalam kilogram, dibagi dengan kuadrat tinggi badan mereka dalam meter. Tingkat yang direkomendasikan berasal dari rekomendasi global Organisasi Kesehatan Dunia yang menunjukkan bahwa kisaran BMI normal adalah antara 18,5 dan 24,9.
                <br />
                Kalkulator ini mengembalikan Indeks Massa Tubuh dan klasifikasi terkait berdasarkan tingkat yang ditentukan oleh Organisasi Kesehatan Dunia. Kalkulator menghitung BMI untuk pria dan wanita.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Indeks Massa Tubuh Dewasa BMI
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="height" className="form-label ms-2">
                      Tinggi Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text ">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Berat Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text ">kg</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                  >
                    Hitung
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMITable classification={classification}></BMITable>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="row">
                <div className="col">
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u> Terjadi Kesalahan :</u>
                      </b>{" "}
                      Harap masukkan tinggi dan berat badan yang valid{" "}
                    </div>
                  )}
                  {result && (
                    <div>
                      <h4>Hasil:</h4>
                      <hr />
                      <div
                        className=" alert alert-success"
                      >
                        {" "}
                        <label>
                          <b> Indeks Massa Tubuh (BMI) : </b>
                          {result.BMI.toFixed(1)} <label> kg/m²</label>
                        </label>
                      </div>
                      <div
                        className=" alert alert-success"
                      >
                        {" "}
                        <label>
                          <b> Klasifikasi: </b> {result.classification}
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>
                  Hitung Indeks Massa Tubuh BMI (Dewasa) - Ukur Kesehatan Tubuh Anda dengan Mudah
                </h2>
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Hitung Indeks Massa Tubuh BMI (Dewasa) - Ukur Kesehatan Tubuh Anda dengan Mudah
                  </h2>{" "}
                </u>
                <br />
                <p>
                  Indeks Massa Tubuh (BMI), yang sebelumnya dikenal sebagai indeks Quetelet, adalah ukuran yang digunakan untuk menentukan status gizi orang dewasa. Ini didefinisikan sebagai berat badan seseorang dalam kilogram dibagi dengan kuadrat tinggi badan seseorang dalam meter (kg/m²). Misalnya, jika berat badan orang dewasa adalah 70 kg dan tingginya 1,75 meter, maka BMI mereka akan menjadi 22,9. 70 (kg) / 1,752 (m²) = 22,9 BMI. Untuk orang dewasa di atas 20 tahun, pengukuran BMI termasuk dalam salah satu yang disebutkan dalam tabel sebelumnya.
                </p>
                <p>
                  Kategori BMI didasarkan pada efek kelebihan lemak tubuh pada penyakit dan kematian, dan berkorelasi baik dengan pengukuran lemak. BMI dikembangkan sebagai indikator risiko penyakit; risiko meningkat seiring dengan peningkatan BMI. Beberapa kondisi umum yang terkait dengan kelebihan berat badan dan obesitas meliputi: kematian dini, penyakit kardiovaskular, tekanan darah tinggi, kerusakan sendi, beberapa jenis kanker, dan diabetes mellitus.
                </p>
                <p>
                  BMI juga direkomendasikan untuk digunakan pada anak-anak dan remaja. Dalam kasus anak-anak, BMI dihitung dengan cara yang sama seperti untuk orang dewasa, kemudian dibandingkan dengan nilai z atau persentil. Selama masa kanak-kanak dan remaja, rasio antara berat dan tinggi bervariasi menurut jenis kelamin dan usia, sehingga nilai batas yang menentukan status gizi individu berusia 0 hingga 19 tahun bergantung pada jenis kelamin dan usia. Titik batas BMI-untuk-usia untuk tahun 2006 untuk anak usia 0 hingga 5 tahun ditetapkan untuk mendiagnosis kelebihan berat badan dan obesitas sebagai persentil 97 dan 99 masing-masing. Untuk individu berusia 5 hingga 19 tahun, kelebihan berat badan didefinisikan sebagai nilai BMI-untuk-usia lebih dari +1
                </p>
                <hr />
                <u>
                  <b>Sejarah:</b>
                </u>{" "}
                <br />
                Indeks Massa Tubuh (BMI) sangat mudah diukur dan dihitung, sehingga merupakan alat yang paling banyak digunakan untuk menghubungkan risiko masalah kesehatan dengan berat badan pada tingkat populasi. Ini dikembangkan oleh Adolphe Quetelet selama abad ke-19. Selama tahun 1970-an berdasarkan data dan laporan studi Tujuh Negara, para peneliti mencatat bahwa BMI tampaknya merupakan indikator yang baik untuk pengukuran lemak dan masalah kelebihan berat badan.
                <br />                Seperti pengukuran lainnya, ini tidak sempurna karena hanya bergantung pada tinggi dan berat badan dan tidak memperhitungkan berbagai tingkat pengukuran lemak berdasarkan usia, tingkat aktivitas fisik, dan jenis kelamin. Karena alasan ini, diperkirakan bahwa ini melebih-lebihkan pengukuran lemak dalam beberapa kasus dan meremehkannya dalam kasus lain.
                <br />                Ada banyak pengukuran lain seperti lingkar pinggang (WC) dan dapat melengkapi perkiraan BMI. Namun, menghubungkan lingkar pinggang dengan risiko kesehatan tidaklah mudah dan harus dilakukan secara ilmiah menggunakan teknik yang tepat.
                <br />                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Manfaat Aktivitas Fisik Teratur{" "}
                  </h2>{" "}
                </u>
                <p>
                  Aktivitas fisik teratur - seperti berjalan, bersepeda, menari - memiliki manfaat kesehatan yang signifikan. Misalnya, dapat mengurangi risiko penyakit jantung dan arteri, diabetes, osteoporosis, dan membantu mengendalikan berat badan serta meningkatkan kesejahteraan mental.
                </p>
                <p></p>
                <p>
                  Partisipasi dalam aktivitas fisik meningkatkan peluang interaksi sosial, komunikasi, dan memperkuat identitas budaya. Aktivitas fisik memiliki dampak positif pada masyarakat dan komunitas dengan mempromosikan interaksi sosial dan kohesi.
                </p>
                <p>
                  Terutama di kalangan anak-anak dan remaja, olahraga dan aktivitas fisik lainnya berkontribusi pada pemberdayaan diri dan peningkatan kepercayaan diri. Selain itu, aktivitas fisik membantu mencegah dan mengendalikan perilaku berisiko, seperti penggunaan tembakau, alkohol, dan zat berbahaya lainnya, makan tidak sehat, dan kekerasan.
                </p>
                <p>
                  Mempromosikan aktivitas fisik juga memiliki dampak positif pada lingkungan. Misalnya, mendorong berjalan dan bersepeda daripada menggunakan kendaraan bermotor mengurangi kemacetan lalu lintas, polusi udara dan suara, serta konsumsi bahan bakar fosil.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Manfaat Diet Seimbang{" "}
                  </h2>{" "}
                </u>
                <ul>
                  <li>
                    Memilih berdasarkan diet seimbang dan bervariasi adalah langkah penting menuju gaya hidup yang bahagia dan sehat.
                  </li>
                  <li>
                    Vitamin dan mineral dalam makanan sangat penting untuk meningkatkan kekebalan tubuh dan pertumbuhan yang sehat.
                  </li>
                  <li>
                    Diet sehat dapat melindungi tubuh manusia dari beberapa jenis penyakit, terutama penyakit tidak menular seperti obesitas, diabetes, penyakit jantung, beberapa jenis kanker, dan kondisi kerangka.
                  </li>
                  <li>
                    Diet sehat juga dapat berkontribusi untuk mempertahankan berat badan yang tepat.
                  </li>
                  <li>
                    Nutrisi sehat adalah kesempatan baik untuk memperkaya kehidupan dengan mencoba berbagai makanan dari budaya dan sumber yang berbeda serta dengan berbagai cara menyiapkan makanan.
                  </li>
                  <li>
                    Manfaat makan berbagai makanan juga mencakup aspek emosional, karena variasi dan warna adalah elemen penting dalam diet seimbang.
                  </li>
                </ul>
                <br />                <b>Sumber: </b>
                <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                  Organisasi Kesehatan Dunia
                </a>{" "}
                <br />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu Indeks Massa Tubuh (BMI)?
                </h3>
              </div>
              <div className="info-section-body">
                Indeks Massa Tubuh (BMI) adalah salah satu metode umum untuk menentukan apakah berat badan Anda sehat atau tidak. Ini digunakan untuk mengukur persentase lemak tubuh berdasarkan berat dan tinggi badan untuk orang dewasa.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung Indeks Massa Tubuh (BMI)?
                </h3>
              </div>
              <div className="info-section-body">
                Indeks Massa Tubuh (BMI) dihitung dengan membagi berat badan seseorang (dalam kilogram) dengan kuadrat tinggi badan mereka (dalam meter). Satuan imperial (pon dan inci) juga dapat digunakan saat mengganti satuan standar. Setelah Anda mendapatkan angka ini, kalikan dengan 703 untuk mendapatkan rasio BMI akhir.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h1 style={{ fontSize: "16px" }}>
                  Apa saja kategori Indeks Massa Tubuh (BMI)?
                </h1>
              </div>
              <div className="info-section-body">
                Setelah menghitung BMI, Anda akan menemukan diri Anda dalam salah satu kategori berikut:
                <ul>
                  <li>Kurang dari 18,5: Kisaran berat badan kurang</li>
                  <li>18,5 hingga 24,9: Kisaran berat badan sehat</li>
                  <li>25,0 hingga 29,9: Kisaran kelebihan berat badan</li>
                  <li>30,0 dan lebih: Kisaran obesitas</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah BMI memberi tahu saya berapa banyak berat badan yang harus saya turunkan?
                </h3>
              </div>
              <div className="info-section-body">
                Indeks itu sendiri tidak akan memberi Anda target untuk menurunkan dan mempertahankan berat badan, tetapi Anda dapat menggunakan tabel BMI yang tersedia di situs National Institutes of Health (NIH) untuk menghitung berapa banyak yang harus Anda turunkan untuk mencapai kisaran BMI yang sehat/normal.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Berapa rata-rata Indeks Massa Tubuh (BMI)?
                </h3>
              </div>
              <div className="info-section-body">
                Menurut Laporan Statistik Kesehatan Nasional 2018 dari Pusat Pengendalian dan Pencegahan Penyakit (CDC), rata-rata BMI untuk wanita Amerika di atas 20 tahun adalah 29,6, dan 29,1 untuk pria Amerika dalam kelompok usia yang sama.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah BMI berbeda antara pria dan wanita?
                </h3>
              </div>
              <div className="info-section-body">
                Meskipun laporan CDC membagi populasi berdasarkan jenis kelamin, BMI tidak membedakan antara pria dan wanita. Ini menggunakan metode yang sama dalam perhitungannya dan kategori yang sama terlepas dari jenis kelamin.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Seberapa akurat Indeks Massa Tubuh (BMI)?
                </h3>
              </div>
              <div className="info-section-body">
                Meskipun BMI adalah indikator yang andal untuk kondisi berat badan, ini tidak sempurna. Indeks ini dirancang untuk mengukur persentase lemak tubuh dan tidak memperhitungkan faktor-faktor seperti massa otot atau kepadatan tulang.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah mengetahui BMI penting untuk penurunan berat badan?
                </h3>
              </div>
              <div className="info-section-body">
                Ini adalah pengetahuan yang berguna untuk Anda miliki, tetapi ini bukan satu-satunya informasi penting yang tersedia bagi Anda dalam hal penurunan berat badan. Seperti yang dibahas sebelumnya, BMI hanya memperkirakan persentase lemak tubuh dan tidak memperhitungkan massa otot, berat air, atau kepadatan tulang. Penentuan yang akurat dari proporsi komponen-komponen ini sangat penting untuk membangun program penurunan berat badan yang sukses.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah BMI berbeda antara pria dan wanita?
                </h3>
              </div>
              <div className="info-section-body">
                Meskipun laporan CDC membagi populasi berdasarkan jenis kelamin, BMI tidak membedakan antara pria dan wanita. Ini menggunakan metode yang sama dalam perhitungannya dan kategori yang sama terlepas dari jenis kelamin.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BMICalculator;